module.exports = {"330102001":"清波街道","330102003":"湖滨街道","330102004":"小营街道","330102008":"南星街道","330102009":"紫阳街道","330102010":"望江街道","330102011":"凯旋街道","330102012":"采荷街道","330102013":"闸弄口街道","330102014":"四季青街道","330102015":"彭埠街道","330102016":"笕桥街道","330102017":"丁兰街道","330102018":"九堡街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330102.json
// module id = 1041
// module chunks = 0